import type { ReceiptTemplate } from '../schema';

export const vistaprintTemplate: ReceiptTemplate = {
  id: 'vistaprint',
  name: 'Vistaprint Receipt',
  brand: 'VISTAPRINT',
  description: 'Vistaprint order receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'vp-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'VISTAPRINT',
        businessNameFontSize: 18,
        addressLines: ['ORDER RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'vp-order',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'VP-847291034' },
          { id: 'customer', label: 'Customer:', value: 'John Doe' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'ship', label: 'Est. Ship:', value: '01/10/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'vp-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'BUSINESS CARDS (500)', quantity: '1', price: '24.99', sku: '' },
          { id: '2', name: 'FLYERS 8.5x11 (100)', quantity: '1', price: '45.99', sku: '' },
          { id: '3', name: 'STANDARD SHIPPING', quantity: '1', price: '7.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'vp-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '78.97', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '6.52', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '85.49', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'vp-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'vp-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'ORDER CONFIRMED\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

